import { useState } from "react";
import { STATIC } from "@/data/content";
import { Preloader } from "@/components/Preloader";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { KineticMarquee } from "@/components/KineticMarquee";
import { CaseStudies } from "@/components/CaseStudies";
import { Stats } from "@/components/Stats";
import { Manifesto } from "@/components/Manifesto";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [, setLoaded] = useState(false);
  return (
    <>
      <Preloader onDone={() => setLoaded(true)} />
      <Header />
      <main>
        <Hero />
        <KineticMarquee />
        <CaseStudies />
        <Stats />
        <Manifesto />
        <Footer />
      </main>
    </>
  );
}
